import {
  ASSETLIST_FETCHITEMS_LOAD,
  ASSETLIST_FETCHITEMS_SUCCEED,
  ASSETLIST_FETCHITEMS_FAIL,
  ASSETLIST_CHANGETABLE_CHANGE,
  ASSETLIST_SEARCHTABLE_EDIT,
  ASSETLIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ASSETLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case ASSETLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case ASSETLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case ASSETLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case ASSETLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case ASSETLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}
